"use strict";

module.exports.log = {
  error: function error() {
    if (console && console.error) {
      var _console;

      (_console = console).error.apply(_console, arguments);
    }
  }
};
//# sourceMappingURL=log.js.map


//////////////////
// WEBPACK FOOTER
// ../~/wix-bi-logger-client/dist/utils/log.js
// module id = 317
// module chunks = 0 1